function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m368.5 368h-16v32h-144v16h144v24c0 13.253906-10.746094 24-24 24h-176c-8.574219-.011719-16.496094-4.582031-20.800781-12l-13.855469 8c7.171875 12.355469 20.371094 19.972656 34.65625 20h176c22.082031-.027344 39.972656-17.917969 40-40zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m232.5 432h16v16h-16zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m280.5 216v-16h-24.40625c-3.988281-51.050781-44.542969-91.605469-95.59375-95.59375v-24.40625h-16v24.40625c-5.390625.414062-10.738281 1.25-16 2.496094v-42.902344h128v-16h-128v-8c0-13.253906 10.746094-24 24-24h176c5.84375 0 11.488281 2.132812 15.871094 6l10.585937-12c-7.304687-6.449219-16.714843-10.00390625-26.457031-10h-176c-22.082031.0273438-39.972656 17.917969-40 40v72c-36.023438 15.089844-60.574219 49.0625-63.59375 88h-24.40625v16h24.425781c3.773438 51.148438 44.425781 91.828125 95.574219 95.632812v24.367188h16v-24.367188c51.148438-3.804687 91.800781-44.484374 95.574219-95.632812zm-136 64v15.632812c-11.160156-1.003906-22.019531-4.140624-32-9.234374v-14.398438c0-22.089844 17.910156-40 40-40s40 17.910156 40 40v14.398438c-9.976562 5.101562-20.839844 8.242187-32 9.257812v-15.65625zm-16-88c0-13.253906 10.746094-24 24-24s24 10.746094 24 24-10.746094 24-24 24-24-10.746094-24-24zm82.664062 81.601562c-.863281.796876-1.785156 1.4375-2.664062 2.175782v-3.777344c-.019531-20.898438-11.675781-40.046875-30.230469-49.664062 12.851563-10.824219 17.566407-28.527344 11.804688-44.308594-5.761719-15.785156-20.773438-26.285156-37.574219-26.285156s-31.8125 10.5-37.574219 26.285156c-5.761719 15.78125-1.046875 33.484375 11.804688 44.308594-18.554688 9.617187-30.210938 28.765624-30.230469 49.664062v3.816406c-.886719-.726562-1.808594-1.410156-2.664062-2.175781-16.578126-14.867187-26.910157-35.460937-28.910157-57.640625h15.574219v-16h-15.59375c3.910156-42.234375 37.359375-75.683594 79.59375-79.59375v15.59375h16v-15.59375c42.234375 3.910156 75.683594 37.359375 79.59375 79.59375h-15.59375v16h15.574219c-2 22.179688-12.332031 42.773438-28.910157 57.640625zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m456.5 144c4.417969 0 8-3.582031 8-8v-96c0-4.417969-3.582031-8-8-8h-176c-4.417969 0-8 3.582031-8 8v96c0 4.417969 3.582031 8 8 8zm-168-96h160v80h-160zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m304.5 64h32v16h-32zm0 0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m352.5 64h80v16h-80zm0 0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m304.5 96h128v16h-128zm0 0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m455.085938 160c-6.195313.011719-12.171876 2.285156-16.800782 6.398438l-69.785156 61.523437v-67.921875h-16v80h2.3125l-45.511719 40.160156c-29.609375 1.695313-52.765625 26.179688-52.800781 55.839844v14.113281c.03125 7.9375-4.457031 15.207031-11.574219 18.726563-3.324219 1.65625-5.070312 5.382812-4.21875 8.996094.851563 3.613281 4.078125 6.167968 7.792969 6.164062h56c29.660156-.035156 54.144531-23.191406 55.839844-52.800781l113.808594-128.976563c6.605468-7.492187 8.210937-18.160156 4.097656-27.265625-4.109375-9.105469-13.171875-14.957031-23.160156-14.957031zm-150.585938 208h-36.585938c3.019532-5.476562 4.597657-11.632812 4.585938-17.886719v-14.113281c.027344-20.839844 16.027344-38.179688 36.800781-39.871094l35.070313 35.070313c-1.6875 20.773437-19.03125 36.777343-39.871094 36.800781zm157.648438-176.359375-110.007813 124.679687-27.960937-27.953124 124.679687-110.015626c3.730469-3.273437 9.359375-3.089843 12.871094.417969 3.507812 3.511719 3.691406 9.140625.417969 12.871094zm0 0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m8.5 440h176c4.417969 0 8-3.582031 8-8v-64c0-4.417969-3.582031-8-8-8h-56v-40h-16v40h-104c-4.417969 0-8 3.582031-8 8v64c0 4.417969 3.582031 8 8 8zm8-64h160v48h-160zm0 0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m32.5 392h40v16h-40zm0 0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m88.5 392h72v16h-72zm0 0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m8.5 112h80c4.417969 0 8-3.582031 8-8v-64c0-4.417969-3.582031-8-8-8h-80c-4.417969 0-8 3.582031-8 8v64c0 4.417969 3.582031 8 8 8zm8-64h64v48h-64zm0 0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m32.5 64h32v16h-32zm0 0"
});

function SvgUi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 140,
    viewBox: "0 0 479 480",
    width: 140,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/ui.c5e3d71f.svg";
export { ForwardRef as ReactComponent };